/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS"
export const API_FAIL = "API_FAIL"
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA"
export const GET_TRAVELAGENCY_DATA = "GET_TRAVELAGENCY_DATA"
export const GET_TOP_TRAVELAGENCY_DATA = "GET_TOP_TRAVELAGENCY_DATA"
export const GET_TRAVELAGENCY_STAFF_DATA = "GET_TRAVELAGENCY_STAFF_DATA"
